import React from 'react';
import { MAINTAINER_ID } from '../lib/config.js';
import m0 from './lifecycle.js';
import m1 from './history.js';
import m2 from './draw.js';
import m3 from './pointer.js';
import m4 from './selection.js';
import m5 from './frames.js';
import m6 from './themes.js';
import m7 from './projects.js';
import m8 from './themes-mod.js';
import m9 from './dialogs.js';
import m10 from './features.js';
import m11 from './dm.js';
import m12 from './features-mod.js';
import m13 from './poll.js';
import m14 from './comments.js';
import m15 from './account.js';
import m16 from './presence.js';
import m17 from './mod.js';
import m18 from './guestbook.js';
import m19 from './account-save.js';
import m20 from './requests.js';
import m21 from './duo.js';
import m22 from './publish.js';
import m23 from './gallery.js';
import m24 from './wip.js';
import m25 from './navigation.js';
import m26 from './chat.js';
import m27 from './tools.js';
import m28 from './render-vals.js';
import m29 from './board.js';
import m30 from './live.js';
import m31 from './desktop.js';
import m32 from './snake.js';
import m33 from './memory.js';
import m35 from './tamagotchi.js';
import m36 from './arcade.js';
import m37 from './ketting.js';
import m38 from './beestje.js';
import m39 from './arena.js';
import m40 from './venster.js';

/**
 * De paal, in één object. Het gedrag staat in de modules hierboven; die worden op
 * het prototype gelegd. Dat is bewust zo gelaten: de code kwam uit één klasse en
 * vrijwel elke methode leest en schrijft dezelfde `this.state`.
 *
 * Dit is géén React-component. De dc-runtime hield de toestand in een gewoon
 * object naast een React-schil, en werkte `state` synchroon bij: direct na
 * `setState` staat de nieuwe waarde er al. Op honderden plekken in deze code
 * wordt daarop geleund. React batcht juist, dus die opzet is hier nagebouwd in
 * plaats van vervangen. App.jsx is de schil.
 */
export default class Component {
  constructor(props) {
    this.props = props || {};
    /** Wordt door App.jsx gezet; de weg terug naar React. */
    this.__host = null;
    this.state = {
      // Alle beelden van deze krabbel. Eén beeld is een stilstaand plaatje; meer
      // beelden wisselen elkaar af. frames[frameIdx] is wat er op het doek staat.
      frames: ['', '', '', '', '', ''],
      frameOn: [true, false, false, false, false, false],
      frameIdx: 0,
      playing: false,
      hoverFrame: -1,
      hasClip: false,
      accountId: '',
      avatar: '',
      accounts: [],
      accountsMissing: false,
      editName: '',
      editAvatar: '',
      avColor: 0,
      avPainting: false,
      // De stapels voor Cmd+Z in de avatar-tekenaar, en of de rechtermuisknop gumt.
      avUndo: [],
      avRedo: [],
      avErase: false,
      // Hoe je avatar erbij stond toen je de tekenaar opendeed; het kruisje brengt
      // je daar naar terug.
      avStart: '',
      avStartDirty: false,
      // Het kader in de avatar-tekenaar: welk gereedschap, welk vlak, en of je het
      // op dit moment versleept.
      avTool: 'pen',
      avSel: null,
      avPreview: null,
      savingAccount: false,
      accountError: '',
      accountHint: '',
      // Het betatesterscherm in het modgereedschap; zie logic/mod.js.
      betaFout: '',
      betaBezig: '',
      likesSeen: 0,
      seenAt: '',
      // Tot welk ideetje je de ideeënbus gezien hebt: de created-stempel van het
      // nieuwste dat je onder ogen kreeg. Leeg betekent "nog nooit gekeken", en dan
      // zet fetchFeatures de streep zelf, zodat je niet begint met een bolletje van
      // zesentwintig. Zie nieuweIdeetjes in logic/features.js.
      featuresSeen: '',
      emojiOpen: false,
      isMobile: typeof window !== 'undefined' && window.innerWidth <= 760,
      /**
       * Het tekenscherm: bestaat het, en is het weggeklapt.
       *
       * Dit was één veld `view` met twee standen die elkaar uitsloten, en dat kon
       * niet meer: op het bureaublad is de paal er altijd en kan het tekenvenster er
       * los bij open staan. De zestien plekken die `view` lazen bedoelden ook drie
       * verschillende dingen; zie tekentNu() in logic/navigation.js.
       *
       * Weggeklapt is niet hetzelfde als dicht: het doek blijft dan in de pagina
       * staan, want zodra het eruit gehaald wordt is je werk weg.
       */
      /**
       * Dicht als je binnenkomt: je ziet eerst de paal.
       *
       * Hij heeft een tijd open gestaan bij binnenkomst, maar de paal is waar je voor
       * komt kijken; tekenen doe je als je daar zin in hebt, via het pictogram of het
       * startmenu. De twee dingen die daarvoor gerepareerd zijn blijven wel staan: de
       * paal ververst ook met een open venster (paalInBeeld) en `#paal` klapt geen
       * venster weg (applyRoute).
       */
      studioOpen: false,
      studioMin: false,
      /** Heb je vandaag getekend? Dan blijft de knop in de taakbalk staan. */
      /*
       * Hier stond `studioGestart`: "heb je vandaag getekend, dan blijft de knop in
       * de taakbalk staan". Die vlag is weg, en met hem tamGestart en ketGestart. Een
       * balkje in de balk betekent nu "dit programma draait", en het kruisje stopt
       * het; wil je hem alleen even uit beeld, dan is er de wegklapknop ernaast. Zie
       * vensterLijst in logic/venster.js.
       */
      tool: 'pencil',
      sel: null,
      hoverTip: null,
      lassoPts: null,
      keyFlash: null,
      // De hulplijnen onder het doek: '' is uit, daarna een kubus en een
      // isometrisch raster. Zie cycleHulp in logic/tools.js.
      hulp: '',
      winH: typeof window !== 'undefined' ? window.innerHeight : 900,
      winW: typeof window !== 'undefined' ? window.innerWidth : 1280,
      accTwoCols: typeof window !== 'undefined' && window.innerWidth > 900 && window.innerHeight < 820,
      shortH: typeof window !== 'undefined' && window.innerHeight < 760,
      primaryIndex: 0,
      brushSize: 1,
      drawing: false,
        canvasPx: 512,
      canvasPxH: 512,
      roomyHeader: true,
      tightHeader: false,
      narrowHeader: false,
      wideChat: false,
      duo: null,
      reqList: [],
      reqLoading: false,
      reqText: '',
      reqTo: '',
      reqHover: '',
      reqSending: false,
      reqError: '',
      activeRequest: null,
      duoInvite: null,
      duoPartnerName: '',
      pbUrl: '',
      author: '',
      connected: false,
      dialog: null,
      notifOpen: false,
      themePopup: false,
      themeHidden: false,
      themeWords: {},
      themeEdits: {},
      themeError: '',
      slot: 0,
      slotArt: ['', ''],
      projError: '',
      notifUnseen: false,
      editPin: '',
      featureList: [],
      dmInbox: [],
      dmTo: null,
      dmText: '',
      dmSending: false,
      dmError: '',
      featureLoading: false,
      pinFor: null,
      pinMode: 'claim',
      pinDigits: ['', '', '', ''],
      pinError: '',
      pinBusy: false,
      pinTries: 0,
      pinLockUntil: 0,
      publishTitle: '',
      publishIsTheme: false,
      publishing: false,
      publishError: '',
      galleryItems: [],
      dailyRec: null,
      dailyNext: null,
      dailyUsed: [],
      wideIds: {},
      galleryLoading: false,
      galleryError: '',
      hoveredId: null,
      pullY: 0,
      pullBusy: false,
      editBio: '',
      bioUnsupported: false,
      avatarEditorOpen: false,
      profileId: null,
      likersOpen: false,
      likersAt: null,
      lastId: '',
      likedIds: [],
      toast: '',
      toastAvatar: '',
      gbPixels: '',
      gbOwners: {},
      gbTip: null,
      gbColor: 0,
      gbUsed: 0,
      gbSaving: false,
      gbMissing: false,
      gbStatus: 0,
      viewerId: null,
      confetti: [],
      undoN: 0,
      redoN: 0,
      notifLimit: 15,
      nowTick: 0,
      // De klok rechtsboven. Zie tickClock in logic/desktop.js.
      klokTijd: '',
      klokDatum: '',
      // Het startmenu linksonder. Zie logic/desktop.js.
      startOpen: false,
      chatOpen: false,
      chatMessages: [],
      comments: {},
      commentText: '',
      commentSending: false,
      commentError: '',
      poll: null,
      pollOpen: false,
      pollVoting: false,
      pollError: '',
      pollQ: '',
      pollA: '',
      pollB: '',
      pollPrevA: '',
      pollPrevB: '',
      pollCreating: false,
      pollFormError: '',
      chatInput: '',
      mentionQuery: null,
      chatSending: false,
      buzzing: false,
      buzzPick: false,
      // Snake. Het speelveld zelf staat in this.spel; hier alleen wat het
      // venster eromheen laat zien. Zie logic/snake.js.
      // Staat paal_beest al op de server? Zolang niet, leeft het beestje alleen in
      // deze browser en zegt het venster dat.
      tamMissing: false,
      tamStatus: 0,
      // Waar het programmaatje staat, en of hij in de taakbalk hoort.
      /** Waar de programmaatjes staan, per venster. Zie logic/venster.js. */
      vensterPlek: {},
      /**
       * Welke vensters weggeklapt zijn: uit beeld, maar het programma draait nog en
       * zijn balkje staat nog in de taakbalk. Zie vensterWeg in logic/venster.js.
       *
       * Het tekenvenster doet niet mee met deze kaart; dat heeft `studioMin`, want
       * daar hangt het bewaren van het doek aan.
       */
      vensterMin: {},
      /**
       * Welk venster bovenop ligt: achteraan in dit rijtje. Zie logic/venster.js.
       *
       * Tekenen staat er meteen in, want dat venster staat al open bij binnenkomst
       * (zie studioOpen hierboven). Zonder deze regel lag het venster er wel, maar
       * met de bleke titelbalk en de korte schaduw van een venster dat achteraan
       * ligt: open en toch niet actief.
       */
      vensterOrde: [],
      /**
       * De twee spelvensters hebben elk hun eigen vlag.
       *
       * Ze hingen aan `state.dialog`, en dat is één plek voor één venster: het slot
       * dat alle twintig schermvullende vensters delen. Daarmee konden de
       * Krabbelgotchi en de Krabbellijn niet samen open staan, terwijl ze allebei
       * een programmaatje op het bureaublad zijn met een knop in de taakbalk. Het
       * tekenvenster kreeg om dezelfde reden `studioOpen`.
       */
      beestOpen: false,
      ketOpen: false,
      /**
       * En hetzelfde voor de schermen die vensters zijn geworden.
       *
       * Het leaderbord, het gastenboek en de arcadehal waren schermvullende lagen die
       * om het slot in `state.dialog` vochten: er kon er één open zijn en hij dekte de
       * taakbalk af. Nu zijn het vensters die je kunt verslepen en die naast elkaar
       * open kunnen staan, dus hebben ze elk een eigen vlag. De krabbelviewer had er
       * al een (`viewerId`).
       */
      activityOpen: false,
      gbOpen: false,
      arcadeOpen: false,
      /*
       * Hier stonden activityGestart, gbGestart en arcadeGestart: "één keer geopend,
       * dan blijft de knop deze sessie staan". Die vlaggen zijn weg. Een balkje in de
       * taakbalk betekent nu "dit programma draait", en het kruisje stopt het; wil je
       * hem alleen even uit beeld, dan is er de wegklapknop ernaast. Zie vensterLijst
       * in logic/venster.js.
       */
      /**
       * Alle beestjes van de paal, zoals ze op de server staan.
       *
       * Voor twee dingen: langs de buren bladeren, en de meldingen bij de bel over
       * wie wie te eten gaf. Zie tamHaalRijen in logic/tamagotchi.js.
       */
      tamRijen: [],
      // De tekenaar voor de mod; zie logic/beestje.js.
      beestjes: {},
      beestjeAan: '',
      beestjeGroep: 'beestje',
      beestjeSlot: 0,
      // De arena; zie logic/arena.js.
      tamMode: '',
      // Het potje dat nu loopt, zoals het op de server staat. De stand zelf wordt
      // uitgerekend uit zaad en zetten; zie logic/arena.js.
      arenaRij: null,
      arenaBezig: false,
      arenaLijst: [],
      arenaFout: '',
      arenaMist: false,
      arenaStatus: 0,
      beestjeKleur: 2,
      beestjeGum: false,
      beestjeVuil: false,
      beestjeBezig: false,
      beestjeFout: '',
      beestjesMist: false,
      beestjesStatus: 0,
      // De drie letterwieltjes onder het schermpje; zie tamNoem in
      // logic/tamagotchi.js.
      tamLetters: ['A', 'A', 'A'],
      tamLetterAan: 0,
      tamNoemt: false,
      // De beestjes van de anderen; zie tamHaalBuren in logic/tamagotchi.js.
      tamBuren: [],
      tamBurenOpen: false,
      tamBurenBezig: false,
      tamVoertBuur: '',
      tamFout: '',
      // De Krabbelgotchi. In de opslag staan tijdstippen, niet balkjes: het leeft
      // door terwijl de app dicht is. Zie logic/tamagotchi.js.
      tamBeest: null,
      tamTik: 0,
      // Wat je net indrukte, en tot wanneer je dat ziet.
      tamActie: null,
      // Krabbellijn. De ketens komen van de server; het vel waar je op tekent
      // staat buiten de toestand, want bij elke streek de hele app opnieuw laten
      // tekenen is zonde. Zie logic/ketting.js.
      ketMode: 'hal',
      ketRijen: [],
      ketKeten: null,
      ketVorige: null,
      ketLezen: null,
      ketZin: '',
      ketIets: false,
      ketSec: null,
      // Het gereedschap, net als bij de avatar: 'pen' of 'sel', en de gum is een
      // kleur die er niet is. Zie logic/ketting.js.
      ketKleur: 0,
      ketTool: 'pen',
      ketSel: null,
      ketVoor: null,
      // Waar je het programmaatje hebt neergezet, en de klok die elke seconde tikt.
      ketNu: 0,
      // Wie je aanwijst in de kiezer; zijn naam staat onder het raster.
      ketWijst: '',
      // Rustig (een kwartier) of samen nu (90 en 45 seconden). Alleen te kiezen als
      // je zelf een keten begint; daarna houdt de keten zijn eigen tempo.
      ketSnel: false,
      // Heb je het spel deze sessie geopend? Zo ja, dan staat het in de taakbalk.
      ketGedaan: 0,
      ketBezig: false,
      ketFout: '',
      ketMissing: false,
      ketStatus: 0,
      // Memory. Het speelveld staat wel in de toestand, anders dan bij
      // Krabbelworm: je draait een kaartje om als je erop tikt, niet veertien keer
      // per seconde. Zie logic/memory.js.
      memSpel: null,
      memBest: 0,
      memBestMs: 0,
      memMs: 0,
      memTop: [],
      memMissing: false,
      memStatus: 0,
      // Staat het geluid van het spelletje uit? Onthouden per browser.
      spelStil: false,
      snakeLoopt: false,
      snakePauze: false,
      snakeDood: false,
      snakeVol: false,
      snakeScore: 0,
      snakeNiveau: 1,
      snakeBest: 0,
      snakeTop: [],
      snakeMissing: false,
      snakeStatus: 0
    };
    this.canvasRef = React.createRef();
    this.avGridRef = React.createRef();
    this.snakeRef = React.createRef();
    this.tamRef = React.createRef();
    this.ketRef = React.createRef();
    // Het aanwijskadertje op het doek. Staat buiten de toestand en wordt direct
    // op de div geschreven; zie setHover in logic/pointer.js.
    this.hoverRef = React.createRef();
    this.hoverCell = null;
    // De paal: waar hangt welke krabbel. Zie logic/board.js.
    this.wallRef = React.createRef();
    this.wallPos = null;
    this.noteEls = new Map();
    this.dragNote = null;
    this.dropRef = React.createRef();
    this.playRef = React.createRef();
    this.chatScrollRef = React.createRef();
    this.accTileRef = React.createRef();
    this.accListRef = React.createRef();
    this.galleryScrollRef = React.createRef();
    this.undoStack = [];
    this.redoStack = [];
    this.opBefore = null;
    this.duoBase = null;
    this.duoSending = false;
    this.duoPendingRemote = null;
    this.savedImage = null;
    this.chatTimer = null;
    this.lastMsgLen = 0;
    this.lastMsgId = '';
    this.galleryTimer = null;
    // Het thema staat vast per dag: iedereen ziet hetzelfde woord.
    this.dayThemes = ['rare baantjes', 'je eerste huisdier', 'maandagochtend', 'wat in je zak zit',
      'een mislukte uitvinding', 'te laat', 'je alter ego', 'iets dat je mist',
      'een slechte gewoonte', 'thuis', 'de kleinste held', 'een plan dat misging',
      'achter de deur', 'je lievelingsgeluid', 'een dier met een baan', 'iets dat piept',
      'een geheim clubje', 'een held op sokken', 'het gereedschap van opa', 'je eerste baantje',
      'de weg naar huis', 'iets dat te groot is', 'de inhoud van je koelkast', 'je slechtste kapsel',
      'het beest onder je bed', 'je oudste kledingstuk', 'een kapot apparaat', 'de plant die je vergat',
      'de kat van de buren', 'een souvenir', 'je bureau om vier uur'];
    // De thema's van vóór 15 augustus 2026. Krabbels van toen horen bij dit
    // rijtje, dus die houden hun eigen thema.
    this.oldThemes = ['de zon', 'een kat', 'het strand', 'de maan', 'een monster', 'de zee', 'een robot',
      'het bos', 'een taart', 'de regen', 'een draak', 'het spook', 'een bloem', 'de sterren',
      'een vogel', 'het vuur', 'een boot', 'de winter', 'een hoed', 'het oog', 'een hond',
      'de wolken', 'een pizza', 'het hart', 'een vis', 'de berg', 'een raket', 'het ijs',
      'een boom', 'de nacht', 'een brief'];
    this.themeSwitchDay = '2026-08-15';
    this.pinRefs = [React.createRef(), React.createRef(), React.createRef(), React.createRef()];
    // ---- Tips ----
    // Elke tool vertelt bij het aanwijzen wat hij doet, met zijn sneltoets. Dit is
    // ook de tekst die een schermlezer voorleest; zie toolLabelFor in logic/tools.js.
    this.toolTips = {
      pencil: { title: 'Potlood', key: 'B', text: 'Vrij tekenen, pixel voor pixel. Sleep voor een lijn.' },
      pen: { title: 'Cirkel, lijn of rechthoek', key: 'P', text: 'Drie tools in één vakje: P wisselt, O, / en R springen naar een vorm. Vormen sleep je van hoek naar hoek; houd Shift vast om ze recht te houden.' },
      spray: { title: 'Spray', key: 'S', text: 'Spettert losse pixels rond je cursor. Hoe langer je blijft hangen, hoe voller het wordt.' },
      fill: { title: 'Vulemmer', key: 'G', text: 'Vult in één klik alles wat aan elkaar vastzit en dezelfde kleur heeft.' },
      eraser: { title: 'Gum', key: 'E', text: 'Veegt pixels weg tot ze weer doorzichtig zijn. Met de rechtermuisknop gum je ook zonder van tool te wisselen.' },
      select: { title: 'Kader of lasso', key: 'M', text: 'Twee tools in één vakje: M is het kader, L de lasso. Sleep je selectie om hem te verplaatsen. Dubbelklik op een kleur om alles van die kleur te pakken.' },
      hulp: { title: 'Hulplijnen', key: 'I', text: 'Lichtblauwe lijnen onder je tekening: een isometrische kubus, of een raster om er een wereld op te zetten. Klikken gaat rond, en ze blijven onder je pixels: wat je zelf zet dekt ze af.' }
    };

    // De methodes stonden ooit als arrow-velden in de klasse en waren dus per
    // instantie gebonden. Ze gaan de template in als losse callback, dus binden
    // we ze hier alsnog. Zonder dit valt `this` weg zodra React ze aanroept.
    bindAll(this);
  }
  get collectionName() { return (this.props.collectionName || 'paal_drawings').trim(); }

  get isMaintainer() { return this.state.accountId === MAINTAINER_ID; }

  // Langste namen eerst, zodat "@Jan Doodle" niet als "@Jan" wordt gelezen.
  get mentionNames() {
    return (this.state.accounts || []).map((a) => a.name).filter(Boolean).slice().sort((a, b) => b.length - a.length);
  }

  /** Patch landt direct in this.state, daarna volgt een hertekening. */
  setState(update, cb) {
    if (this.__host) this.__host.applyState(update, cb);
  }

  forceUpdate() {
    if (this.__host) this.__host.forceUpdate();
  }
}

Object.assign(Component.prototype, m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14, m15, m16, m17, m18, m19, m20, m21, m22, m23, m24, m25, m26, m27, m28, m29, m30, m31, m32, m33, m35, m36, m37, m38, m39, m40);

function bindAll(instance) {
  const proto = Object.getPrototypeOf(instance);
  for (const name of Object.getOwnPropertyNames(proto)) {
    if (name === 'constructor') continue;
    const desc = Object.getOwnPropertyDescriptor(proto, name);
    if (!desc || typeof desc.value !== 'function') continue;
    instance[name] = desc.value.bind(instance);
  }
}
